import React from 'react';
import { space, layout, flexbox, grid, color, system } from 'styled-system';

import styled from 'styled-components';

const DefaultBox = ({ component = 'div', children, className, otherProps = {}, ...props }) => {
  return React.createElement(component, { children, className, ...otherProps });
};

const StyledBox = styled(DefaultBox)`
  ${space}
  ${layout}
  ${flexbox}
  ${grid}
  ${color}
  ${system({
    negativeMarginTop: {
      property: 'marginTop',
      scale: 'space',
      transform: (value, scale) => {
        if (value.includes('px')) {
          return `-${value}`;
        }
        return scale ? `-${scale[value]}px` : `0`;
      },
    },
    negativeMarginLeft: {
      property: 'marginLeft',
      scale: 'space',
      transform: (value, scale) => {
        if (value.includes('px')) {
          return `-${value}`;
        }
        return scale ? `-${scale[value]}px` : `0`;
      },
    },
    distributedWidth: {
      property: 'width',
      scale: 'space',
      transform: (value, scale) => {
        if (value) {
          if (value.includes('px')) {
            return `calc(100% + ${value})`;
          }
          return scale ? `calc(100% + ${scale[value]}px)` : `0`;
        }
        return 'auto';
      },
    },
  })}
`;

export default StyledBox;
